import { defineMessages } from 'react-intl';

export default defineMessages({
    renewalWarning: {
        id: 'wmic-pe-capability-gateway-policychange-common-react.RenewalWarning.RenewalWarningMessage',
        defaultMessage:
            'Renewal in progress. This policy change &lt;b&gt;will not carry forward&lt;/b&gt; to the renewal term.',
    },
});
